<script setup>
import { h, isVNode } from 'vue';
import { isTeletelIcon, teletelIconMarkup } from './teletelIcons';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
});

const renderIcon = () => {
  if (!props.icon) return null;
  if (typeof props.icon === 'function' || isVNode(props.icon)) {
    return props.icon;
  }
  // Teletel's two-tone icons are real SVG, not a CSS mask: a mask paints one
  // colour and these carry a neutral body plus an accent. The markup is a
  // constant in this repo - nothing here ever comes from user input.
  if (isTeletelIcon(props.icon)) {
    return h('span', {
      class: 'inline-flex items-center justify-center',
      innerHTML: teletelIconMarkup(props.icon),
    });
  }
  return h('span', { class: props.icon });
};
</script>

<template>
  <component :is="renderIcon" />
</template>
